import React from "react";
import { BiHeart } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

function ArtistCollectionGrid({ datas, location }) {
  const navigate = useNavigate();

  const nftDetails = (e,type) => {
    navigate("/nft-details", { state: { page: e, type:type } });
  };
  return (
    <div className="artistCollection pt-4">
      {datas.map((e, index) => {
        return (
          <div className="artistCollectionCard" key={index}>
            <div className="artistContainer">
              <img src={e.mainImg} alt="creation" className="mainImg" />
              <div className="heartLike">
                <BiHeart /> <span className="ms-2">5</span>
              </div>
              {index === 1 || index === 4 || index === 7 || index === 9 ? (
                <div className="timeStamp">02h 48m 55s</div>
              ) : (
                ""
              )}
            </div>
            <h5 className="pt-4 d-flex align-items-center">
              {location.state.id.profileName}
              <img src="signed 1.png" alt="tick" className="tick ms-2" />
            </h5>
            <p className="numberCards pt-1">
              {location.state.id.profileName} #234
            </p>
            <div className="priceofCollection">
              <div className="d-flex opacity-50 bids">
                <div className="w-50 ">Price</div>
                <div>Highest bid</div>
              </div>
              <div className="d-flex bidAMounts ">
                <div className="w-50 ">16.5 ETH</div>
                <div>10.5 ETH</div>
              </div>
            </div>
            {index === 1 ||
            index === 2 ||
            index === 5 ||
            index === 7 ||
            index === 10 ? (
              <button
                className="mt-3 buyNowandbid"
                onClick={() => nftDetails(e,"bid")}
              >
                Place a bid
              </button>
            ) : (
              <button
                className="mt-3 buyNowandbid"
                onClick={() => nftDetails(e,"buy")}
              >
                BUY NOW
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default ArtistCollectionGrid;
